import { observer } from 'mobx-react';
import React, { useCallback, useEffect, useState } from 'react';
import Map, { Layer, Source } from 'react-map-gl';
import { useBoundaryLayers } from '../hooks/useBoundaryLayers';
import { useMapState } from '../hooks/useMapState';
import { useStores } from '../stores/useStores';
import DrawControl from './DrawControl';
import PreviewButton, { monoStyle } from './PreviewButton';

function EditTrappingZoneMap({ boundary, setBoundary, id }) {
  const { traplogStore } = useStores();
  const [mapStyle, setMapStyle] = useState(monoStyle);
  const layers = useBoundaryLayers([0.2, 0.4, 4, 0.5]);
  const [boundaryData, , viewport, setViewport, , mapRefWrapper] =
    useMapState();

  useEffect(() => {
    const boundary = boundaryData.features.find(
      (element) => element.properties.id === id
    );
    setBoundary(boundary);
  }, []);

  const onEditorUpdate = useCallback((map) => {
    if (map.features && map.features.length > 0) {
      setBoundary(map.features[0]);
    }
  }, []);

  const onMapClick = useCallback(
    (e) => {
      const clickedFeature = e.features && e.features[0];
      if (!clickedFeature && boundary) {
        const targetZone = traplogStore.trappingZones.find(
          (zone) => zone.id === boundary.properties.id
        );
        const newZones = traplogStore.trappingZones.filter(
          (zone) => zone.id !== boundary.properties.id
        );
        targetZone.boundry = JSON.stringify(boundary.geometry);
        newZones.push(targetZone);
        traplogStore.trappingZones = newZones;
      }
    },
    [boundary, traplogStore.trappingZones]
  );

  return (
    <Map
      ref={mapRefWrapper}
      initialViewState={viewport}
      onViewportChange={(nextViewport) => setViewport(nextViewport)}
      mapStyle={`mapbox://styles/hortplus/${mapStyle}`}
      mapboxAccessToken={process.env.REACT_APP_MAPBOX_ACCESS_TOKEN}
      onClick={onMapClick}
    >
      <DrawControl
        initialBoundry={boundary}
        position='top-right'
        displayControlsDefault={false}
        controls={{ polygon: true, trash: true }}
        defaultMode={boundary ? 'simple_select' : 'draw_polygon'}
        onUpdate={onEditorUpdate}
      />
      <Source id='trappingZones' type='geojson' data={boundaryData}>
        {layers.map((layer) => (
          <Layer key={layer.id} {...layer} />
        ))}
      </Source>
      <PreviewButton
        setMapStyle={setMapStyle}
        mapStyle={mapStyle}
        viewport={viewport}
      />
    </Map>
  );
}

export default observer(EditTrappingZoneMap);
